/**
 *
 * GSTR-9C New Save Reducer
 *
 */

import {
  LOADER_STATUS,
  SET_SAVE_TABLE_DATA,
  SET_FETCH_TABLE_DATA,
  SET_SELECTED_SAVE,
  SET_SELECTED_ROW_SAVE,
  SET_SELECTED_FETCH,
  SET_SELECTED_ROW_FETCH,
} from './constants';

export const initialState = {
  loaderStatus: false,
  saveTableData: [],
  fetchTableData: [],
  selectedSave: [],
  selectedRowSave: [],
  selectedFetch: [],
  selectedRowFetch: [],
};

const gstr9CNewSaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };

    case SET_SAVE_TABLE_DATA:
      return {
        ...state,
        saveTableData: action.saveTableData,
      };

    case SET_FETCH_TABLE_DATA:
      return {
        ...state,
        fetchTableData: action.fetchTableData,
      };

    case SET_SELECTED_SAVE:
      return {
        ...state,
        selectedSave: action.selectedRows,
      };

    case SET_SELECTED_ROW_SAVE:
      return {
        ...state,
        selectedRowSave: action.selectedRowData,
      };

    case SET_SELECTED_FETCH:
      return {
        ...state,
        selectedFetch: action.selectedRows,
      };

    case SET_SELECTED_ROW_FETCH:
      return {
        ...state,
        selectedRowFetch: action.selectedRowData,
      };

    default:
      return state;
  }
};

export default gstr9CNewSaveReducer;